import Image from 'components/global/Image';

import Icon from './Icon';
import Popper from './Popper';
import Tooltip from './Tooltip';
import Typography from './Typography';
import * as S from './styled/Menu.styled';

/**
 * @author Burak Unsal
 */

const Menu = (props) => {
	const {
		buttonRef,
		menuItems,
		emptyText = 'noMenuItems',
		placement,
		offsetX,
		offsetY,
		containerCss,
		hoverMode,
		closeTimeout,
		mobileTitle
	} = props;

	const handleMenuItemClick = (action) => {
		action();
	};

	return (
		<>
			{buttonRef && (
				<Popper
					refElement={buttonRef}
					placement={placement}
					offsetX={offsetX}
					offsetY={offsetY}
					containerCss={containerCss}
					hoverMode={hoverMode}
					closeTimeout={closeTimeout}>
					{(closePopper) => (
						<S.Menu>
							{mobileTitle && (
								<S.MobileTitleContainer>
									<Typography variant="p1" fontWeight="500">
										{mobileTitle}
									</Typography>
								</S.MobileTitleContainer>
							)}

							{menuItems ? (
								menuItems.map((item, index) => {
									if (item.render === false) return;
									return (
										<Tooltip key={index} title={item.disabled} placement="right">
											<S.MenuItem
												id={item.label ? `action_${item.label}` : `action_${index}`}
												className={`menu-item ${item.disabled ? 'disabled' : ''} ${
													item.selected ? 'selected' : ''
												}`}
												onMouseDown={(e) => e.stopPropagation()}
												onTouchEnd={(e) => e.stopPropagation()}
												onClick={() => {
													handleMenuItemClick(item.action);
													closePopper();
												}}>
												{item.icon && <Icon icon={item.icon} />}
												{item.img && <Image url={item.img} {...item.imgProps} />}
												<Typography>{item.label}</Typography>
											</S.MenuItem>
										</Tooltip>
									);
								})
							) : (
								<S.MenuItem className="disabled">
									<Typography>{emptyText}</Typography>
								</S.MenuItem>
							)}
						</S.Menu>
					)}
				</Popper>
			)}
		</>
	);
};

export default Menu;
